export const LIST_POST = 'LIST_POST';
export const SHOW_POST = 'SHOW_POST';
export const CREATE_POST = 'CREATE_POST';
export const UPDATE_POST = 'UPDATE_POST';
export const DATA_REMOVE_POST = 'DATA_REMOVE_POST';
export const DELETE_POST = 'DELETE_POST';